export const BundleSvg=<svg
xmlns="http://www.w3.org/2000/svg"
width="29.982"
height="27.751"
viewBox="0 0 29.982 27.751"
>
<g
    id="add"
    transform="translate(0.001 -18.957)"
>
    <g
        id="Group_12711"
        data-name="Group 12711"
        transform="translate(0.466 19.476)"
    >
        <g
            id="Group_12710"
            data-name="Group 12710"
            transform="translate(0 0)"
        >
            <g
                id="Group_12709"
                data-name="Group 12709"
            >
                <path
                    id="Path_7780"
                    data-name="Path 7780"
                    d="M13.918,48.8a6.819,6.819,0,0,1-3.944,4.841h0a5.356,5.356,0,0,0,8.163-.075A13.08,13.08,0,0,0,25.6,55.894,13.271,13.271,0,1,0,13.916,48.8Z"
                    transform="translate(-9.852 -29.193)"
                    fill="#fff"
                />
                <path
                    id="Path_7781"
                    data-name="Path 7781"
                    d="M23.669,54.571a13.155,13.155,0,0,1-7.447-2.3,5.444,5.444,0,0,1-8.245.015l-.054-.062.07-.07.016-.007a6.726,6.726,0,0,0,3.886-4.745,13.5,13.5,0,0,1-1.523-6.23A13.357,13.357,0,0,1,14.266,31.7a13.228,13.228,0,0,1,18.805,0,13.465,13.465,0,0,1,0,18.943A13.161,13.161,0,0,1,23.669,54.571Zm-7.478-2.532.066.046a12.98,12.98,0,0,0,7.412,2.31,13.219,13.219,0,1,0-13.12-13.218,13.328,13.328,0,0,0,1.476,6.1l.087-.046-.037.182A6.9,6.9,0,0,1,8.19,52.263a5.268,5.268,0,0,0,7.949-.163Z"
                    transform="translate(-7.923 -27.781)"
                    fill="#fff"
                />
            </g>
        </g>
        <path
            id="Path_7782"
            data-name="Path 7782"
            d="M18.408,43.377a17.811,17.811,0,0,1,6.434-13.721,13.334,13.334,0,0,0-10.927,19.5h0A6.819,6.819,0,0,1,9.972,54h0a5.356,5.356,0,0,0,8.163-.075,13.077,13.077,0,0,0,5.624,2.2A17.794,17.794,0,0,1,18.408,43.377Z"
            transform="translate(-9.851 -29.546)"
            fill="#d2dcfd"
        />
        <circle
            id="Ellipse_1862"
            data-name="Ellipse 1862"
            cx="7.245"
            cy="7.245"
            r="7.245"
            transform="translate(5.499 13.349) rotate(-45)"
            fill="#67ccd1"
        />
    </g>
    <g
        id="Group_12713"
        data-name="Group 12713"
        transform="translate(-0.001 18.957)"
    >
        <path
            id="Path_7783"
            data-name="Path 7783"
            d="M150.212,137.169a7.834,7.834,0,1,1,7.834-7.834A7.843,7.843,0,0,1,150.212,137.169Zm0-14.491a6.657,6.657,0,1,0,6.657,6.657A6.665,6.665,0,0,0,150.212,122.678Z"
            transform="translate(-134 -115.467)"
            fill="#052a75"
        />
        <g
            id="Group_12712"
            data-name="Group 12712"
            transform="translate(0 0)"
        >
            <path
                id="Path_7784"
                data-name="Path 7784"
                d="M25.969,23A13.793,13.793,0,0,0,6.454,23,14.015,14.015,0,0,0,3.909,39.118,6.225,6.225,0,0,1,.352,43.341a.592.592,0,0,0-.209.926,5.971,5.971,0,0,0,8.7.307,13.778,13.778,0,0,0,17.127-1.926A14.031,14.031,0,0,0,25.969,23ZM16.211,45.543a12.9,12.9,0,0,1-7.287-2.3.592.592,0,0,0-.626.184,4.791,4.791,0,0,1-6.716.607,7.411,7.411,0,0,0,3.524-4.874.586.586,0,0,0-.067-.416C.606,30.446,6.8,20.025,16.212,20.107,32.953,20.8,32.949,44.848,16.211,45.543Z"
                transform="translate(0.001 -18.957)"
                fill="#052a75"
            />
            <path
                id="Path_7785"
                data-name="Path 7785"
                d="M213.36,188.378h-2.929v-2.929a.588.588,0,1,0-1.177,0v2.929h-2.929a.588.588,0,1,0,0,1.177h2.929v2.928a.588.588,0,1,0,1.177,0v-2.928h2.929a.588.588,0,1,0,0-1.177Z"
                transform="translate(-193.631 -175.098)"
                fill="#052a75"
            />
        </g>
    </g>
</g>
</svg>